import React, { createContext, useState } from 'react';
import { getUserPermissions } from './handle-token-permissions';

export const PermissionsContext = createContext();

export const PermissionsContextProvider = ({ children }) => {
  const [userPermissions, setUserPermissions] = useState({
    mainProfile: {
      role: null,
      permissions: null,
      isSuper: null
    },
    fallbackProfile: null
  });

  const addUserPermissions = (user) => setUserPermissions(getUserPermissions(user));

  return (
    <PermissionsContext.Provider value={{
        userPermissions,
        addUserPermissions,
      }}>
      {children}
    </PermissionsContext.Provider>
  );
};